import PaymentDescription from './payment-description.vue';

export default PaymentDescription;
